var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCustomize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49566 3.40162H3.35677V1.26273C3.35677 1.06585 3.19717 0.90625 3.00029 0.90625C2.80341 0.90625 2.64381 1.06585 2.64381 1.26273V3.40162H0.504919C0.308041 3.40162 0.148438 3.56122 0.148438 3.7581C0.148438 3.95498 0.308041 4.11458 0.504919 4.11458H2.64381V6.25347C2.64381 6.45035 2.80341 6.60995 3.00029 6.60995C3.19717 6.60995 3.35677 6.45035 3.35677 6.25347V4.11458H5.49566C5.69254 4.11458 5.85214 3.95498 5.85214 3.7581C5.85214 3.56122 5.69254 3.40162 5.49566 3.40162Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomize);
export default __webpack_public_path__ + "static/media/AddCustomize.b5dbdd474ec42178806758ae38250e00.svg";
export { ForwardRef as ReactComponent };